export const fmtDate = (iso) => {
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const dayMonth = (iso) => {
  const d = new Date(iso);
  return {
    day: String(d.getDate()).padStart(2, "0"),
    month: new Intl.DateTimeFormat("fr-FR", { month: "short" }).format(d).replace(".", ""),
    year: d.getFullYear(),
  };
};

export const TEAM_LABELS = {
  feminine: "Féminine N1/UCI",
  masculine: "Équipe Homme N3",
  jeunes: "École de Vélo",
  loisir: "Loisir et Cyclo",
};
